import { useParams } from 'react-router';

import { AxiosResponse } from 'axios';
import { FormikHelpers } from 'formik';
import { enqueueSnackbar } from 'notistack';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoCondicoesPagamento } from 'pages/compra/configuracao-pedido/types';

export function useMutateCondicoesPagamento() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<ConfigPedidoCondicoesPagamento>>();
    const { setActiveStepSaved } = useConfigPedidoStepContext();
    const { showError } = useShowError();
    const { id } = useParams();

    /**
     * Valida se todas as lojas possuem ao menos uma condição de pagamento.
     */
    const validateCondicoesPagamento = (values: ConfigPedidoCondicoesPagamento) => {
        const invalidLoja = values.condicaoPagamentoLoja.find((loja) => !loja.condicaoPagamentoList.length);

        if (invalidLoja) {
            enqueueSnackbar(
                <div>
                    A loja <b>{invalidLoja.loja.dsNomeFantasia}</b> deve possuir ao menos uma condição de pagamento
                </div>,
                { variant: 'error' },
            );

            return false;
        }

        return true;
    };

    const onSubmit = (values: ConfigPedidoCondicoesPagamento, { resetForm }: FormikHelpers<ConfigPedidoCondicoesPagamento>) => {
        if (!validateCondicoesPagamento(values)) return;

        mutate(
            {
                url: `/gestao/configpedidocondicaopagamentowrapper?idConfigPedido=${id}`,
                formData: values,
                preventSnack: true,
                preventRedirect: true,
            },
            {
                onSuccess: ({ data }) => {
                    resetForm({ values: data });

                    setActiveStepSaved();

                    enqueueSnackbar('Condições de Pagamento salvas com sucesso', { variant: 'success' });
                },
                onError: (error: any) => showError(error, 'Erro ao salvar Condições de Pagamento'),
            },
        );
    };

    return { onSubmit, isLoading };
}
